var parent = require('../../es/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/slice.js
// module id = 1335
// module chunks = 25